import useSWRMutation from 'swr/mutation';
import { User, UserRole } from 'APIs/letrusAPI/user/types';
import { isProdEnvironment } from 'utils/environment';
import flagrAPI from '../axiosInstance';
import { FeatureFlag } from './types';

function fetchFeatureFlagsRequest() {
  return useSWRMutation<
    FeatureFlag[],
    Error,
    string,
    {
      user?: User;
      flagKeys: string[];
      userRoles?: UserRole[];
    }
  >(
    '/api/v1/evaluation/batch/',
    async (_, { arg }) => {
      try {
        if (!arg.user || !arg.userRoles) {
          throw new Error('User data is required to fetch feature flags');
        }

        const userRole = arg.userRoles?.[0] || {};

        const response = await flagrAPI('/api/v1/evaluation/batch/', {
          method: 'post',
          data: {
            flagKeys: arg.flagKeys,
            enableDebug: true,
            entities: [
              {
                entityContext: {
                  isCategoryPVT: arg.userRoles?.some(
                    (role) => role.school_category === 'PVT'
                  ),
                  isDev: !isProdEnvironment(),
                  user_id: String(arg.user.id),
                  school_id: String(userRole.school),
                  network_id: String(userRole.school_network_id),
                  school_group_id: String(userRole.school_group),
                  is_em_teacher: arg.userRoles?.some((role) =>
                    role.school_group_name?.includes('EM')
                  ),
                  is_coordinator: arg.user?.is_superuser || arg.user?.is_staff,
                },
              },
            ],
          },
        });

        sessionStorage.setItem(
          'featureFlags',
          JSON.stringify(response.data.evaluationResults)
        );

        return response.data.evaluationResults;
      } catch (error) {
        const message = (error as Error)?.message;

        throw new Error(message ?? 'Não foi possível obter as flags');
      }
    },
    {
      throwOnError: false,
    }
  );
}

export default fetchFeatureFlagsRequest;
